<template>
    <ul class="l-menu-list">
      <li v-for="(item, idx) in menuList"
          :key="idx"
          @click="touchMenu(idx)"
          class="l-menu-item">
          <label class="l-menu-dot" v-if="item.unRead>0"></label>
          <img :src="menuActive === idx ? item.image : item.imageDefault" :alt="item.text" class="l-menu-img">
      </li>
    </ul>
</template>

<script>
import TabBaseinfoActive from './images/tab-baseinfo-active.png'
import TabBaseinfo from './images/tab-baseinfo.png'
import TabGiftActive from './images/tab-gift-active.png'
import TabGift from './images/tab-gift.png'

export default {
  name: "l-menu",
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menuActive: 0,
      menuList: [
        {
          text: "基础信息", //  列表文案
          type: 1, //  你使用的数据 可自定义
          active: 1, //  是否选中
          unRead: 0, //  是否有消息
          image: TabBaseinfoActive, //  选中图片
          imageDefault: TabBaseinfo, //  未选中图片
        },
        {
          text: "礼物",
          type: 2,
          active: 0,
          unRead: 0,
          image: TabGiftActive,
          imageDefault: TabGift,
        },
      ],
    };
  },
  methods: {
		//切换菜单展示
		touchMenu(idx) {
			this.menuActive = idx
      this.$emit('update:value', idx)
		},
  },
};
</script>

<style scoped>
.l-menu-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.l-menu-item {
  position: relative;
  width: 120px;
  height: 94px;
  cursor: pointer;
}
.l-menu-dot {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
}
.l-menu-img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
